import { Injectable } from '@angular/core';
import 'rxjs/Rx';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { HttpManagerService } from '../../api/httpmanager.service';
@Injectable()
export class ReplaceDataService {
    constructor(
        private httpmanagerService: HttpManagerService
    ) {
    }
    // Replacedata(key): Promise<any> {
    //     return this.httpmanagerService.HttpPostreplace('admin/replacedata', JSON.stringify(key), "").then(data => {
    //         return data;
    //     })
    // }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/api/replacedata/replacedata.service.ts